import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Bookmark } from "lucide-react";
import { getCases } from "@/lib/apiClient";
import { CaseCard } from "@/components/CaseCards";
import { useSite } from "@/context/SiteContext";

export default function Saved() {
  const { saved } = useSite();
  const [all, setAll] = useState([]);
  useEffect(() => { window.scrollTo(0, 0); getCases({ limit: 500 }).then(setAll); }, []);

  const cases = all.filter((c) => saved.includes(c.slug));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="enter">
        <p className="eyebrow text-ink/60">Your reading list</p>
        <h1 className="font-display font-extrabold text-5xl sm:text-6xl display-tight uppercase mt-3">Saved</h1>
      </div>

      {cases.length === 0 ? (
        <div data-testid="saved-empty-state" className="border-2 border-ink p-12 text-center mt-10">
          <Bookmark size={32} className="mx-auto mb-3" />
          <h3 className="font-display font-extrabold text-2xl">Nothing saved yet.</h3>
          <p className="text-ink/60 mt-2 max-w-md mx-auto">Bookmark any transformation while you browse to build a reading list.</p>
          <Link to="/" className="group btn-tactile mt-5 inline-flex items-center gap-2 bg-ink text-white font-bold px-5 h-11 hover:bg-cobalt">
            Browse Discover <ArrowRight size={18} className="arrow-move" />
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {cases.map((c) => <CaseCard key={c.slug} c={c} />)}
        </div>
      )}
    </div>
  );
}
